import {
    EXIBIR_DOC,
    EXIBIR_DOC_SUCCESS,
    EXIBIR_DOC_FAIL,

    ARQUIVO,
    ARQUIVO_SUCCESS,
    ARQUIVO_FAIL,

    LIMPA_MSG,

    
    SIG_CONTATAR,
    SIG_CONTATAR_SUCCESS,
    SIG_CONTATAR_FAIL,
    LOGIN_SIG_SUCCESS,
    ADD_STATE
} from '../actions/types'

const INITIAL_STATE = {
    exibir_doc: localStorage.getItem('documento') || undefined,
    exibir_doc_load: false,

    arquivo_load: false,
    arquivo_msg: '',
    arquivo_error: false,

    contatar_load: false,
    historico: undefined
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case EXIBIR_DOC: 
            return {
                ...state,
                exibir_doc_load: true,
                exibir_doc: undefined
            }
        case EXIBIR_DOC_SUCCESS: 
            return {
                ...state,
                exibir_doc: action.payload,
                exibir_doc_load: false,
            }
        case EXIBIR_DOC_FAIL: 
            return {
                ...state,
                exibir_doc: undefined,
                exibir_doc_load: false,
            }
        case ARQUIVO:
            return {
                ...state,
                arquivo_load: true,
                arquivo_msg:'',
                arquivo_error: false
            }
        case ARQUIVO_SUCCESS:
            return {
                ...state,
                arquivo_load: false,
                arquivo_msg: action.payload,
                arquivo_error: false
            }
        case ARQUIVO_FAIL:
            return {
                ...state,
                arquivo_load: false,
                arquivo_msg: action.payload,
                arquivo_error: true
            }
        case LIMPA_MSG: 
            return{
                ...state,
                arquivo_error: false,
                arquivo_msg: '',
            }
        case SIG_CONTATAR:
            return {
                ...state,
                contatar_load: true,
                arquivo_msg: ''
            }
        case SIG_CONTATAR_SUCCESS:
            return {
                ...state,
                contatar_load: false,
                arquivo_error: false,
                arquivo_msg: action.payload
            }
        case SIG_CONTATAR_FAIL:
            return {
                ...state,
                contatar_load: false,
                arquivo_msg: action.payload,
                arquivo_error: true
            }
        case ADD_STATE:
            return { ...state, ...action.payload }
        default:
            return state
    }
}